module.exports = __webpack_public_path__ + "img/zoom-in.d276af1a.svg";